/* unplugin-vue-components disabled */import script from "./CensusRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./CensusRegister.vue?vue&type=script&setup=true&lang=js"

import "./CensusRegister.vue?vue&type=style&index=0&id=2c13d60e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c13d60e"]])

export default __exports__